import "./customer-auth-shell.scss";

import { LocalProfile } from "@core/model/local-profile";
import { ApiToFormService } from "@core/services/api-to-form.service";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { PROFILE } from "@core/utility/settings";
import { useQyGetPerson } from "@factory/query/person.query";
import StorageService from "@shared/services/storage.service";
import { Outlet } from "react-router-dom";

import { appConfig } from "../../../app.config";
import { appFeature } from "../../../app.feature";
import { useAuthCustomerNavigation } from "./auth-customer-navigation";

 
export interface CustomerAuthShellProps {}

export function CustomerAuthShell() {
  const { getAuthUser } = useUserIdentityContext();
  const logo = `${
    appConfig.assetPath
  }/icon-192x192.png?${new Date().toISOString()}`;
  const { headerElement } = useAuthCustomerNavigation(logo, appFeature.company);
  const { userCode } = getAuthUser();

  // PERSON API
  const handlePersonSuccess = (response: any) => {
    const mappedData = ApiToFormService.MapProfile(response.data[0]);
    StorageService.save<LocalProfile>(PROFILE, mappedData);
  };
  useQyGetPerson(
    "",
    1,
    0,
    undefined,
    { code: userCode },
    !!userCode,
    handlePersonSuccess
  );

  return (
    <div id="CustomerAuthShell" className="customer-auth-shell">
      {headerElement}

      <section className="flex mt-4">
        <section className="flex-1 bg-gray-50 rounded-lg mr-4 ml-4 md:ml-0 overflow-y-auto">
          <Outlet />
        </section>
      </section>
    </div>
  );
}

export default CustomerAuthShell;
